module.exports = __webpack_public_path__ + "static/media/emoji4.f85ada73.svg";